module.exports = __webpack_public_path__ + "img/help_address_en.b1c73a84.png";